export const BACKUP_MOBILE_BREAKPOINT = 800;